/* eslint-disable no-unused-vars */
import { call, put, takeLatest, select } from "redux-saga/effects";
import {
    types,
    selectors as afipPaymentLinkSelectors,
    actions as afipPaymentLinkActions,
} from "reducers/afipPaymentLink";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";
import * as formUtils from "util/form";
import { replace } from "connected-react-router";
import {
    listVeps,
    listTaxpayers,
    addTaxpayer,
    deleteVEPTaxpayer,
    accessAfipPortal,
    deleteVEP,
    downloadVepDetail,
    processVepPayment,
    getPaymentScheduleRequest,
    getDebtByCuitRequest,
    addEntityRequest,
    processServicesPayment,
    addServicesPaymentPre,
    verifyServiceSchedule,
    adheredServicesList,
    deleteAdheredService,
    editAdheredService,
    newServicesPaymentPre,
    linkService,
    generateServicePayment,
    listPaymentsHistory,
} from "middleware/afipPaymentLink";

import { downloadPdf } from "util/download";
import { credentialsErrorMessage } from "util/validateMessage";

const sagas = [
    takeLatest(types.LIST_VEPS_REQUEST, getVepsList),
    takeLatest(types.LIST_TAXPAYERS_REQUEST, getTaxpayerList),
    takeLatest(types.ADD_TAXPAYER_REQUEST, addNewTaxpayer),
    takeLatest(types.DELETE_TAXPAYER_REQUEST, deleteTaxpayer),
    takeLatest(types.DELETE_VEP_REQUEST, deleteVep),
    takeLatest(types.ACCESS_AFIP_PORTAL_REQUEST, accessAfipPortalRequest),
    takeLatest(types.DOWNLOAD_VEP_DETAIL_REQUEST, downloadVepDetailRequest),
    takeLatest(types.PROCESS_VEP_PAYMENT_REQUEST, processVepPaymentRequest),
    takeLatest(types.GET_PAYMENT_SCHEDULE_REQUEST, getPaymentSchedule),
    takeLatest(types.GET_DEBT_BY_CUIT_REQUEST, getDebtByCuit),
    takeLatest(types.AFIP_SERVICES_ADD_ENTITY_REQUEST, addEntity),
    takeLatest(types.PROCESS_SERVICES_PAYMENT_REQUEST, processServicesPaymentRequest),
    takeLatest(types.ADD_SERVICE_PRE_REQUEST, addServicePreRequest),
    takeLatest(types.VERIFY_SERVICE_SCHEDULED_REQUEST, verifyServiceScheduleRequest),
    takeLatest(types.AD_SERVICE_LIST_REQUEST, adheredServiceList),
    takeLatest(types.AD_SERVICE_DELETE_REQUEST, deleteAdheredServiceRequest),
    takeLatest(types.AD_SERVICE_EDIT_REQUEST, editAdheredServiceRequest),
    takeLatest(types.NEW_SERVICE_PAYMENT_PRE_REQUEST, newServicePaymentPreRequest),
    takeLatest(types.LINK_SERVICE_REQUEST, linkServiceRequest),
    takeLatest(types.GENERATE_SERVICE_PAYMENT_REQUEST, generateServicePaymentRequest),
    takeLatest(types.LIST_PAYMENTS_REQUEST, listPaymentsHistoryRequest),
];

function* getVepsList(params) {
    const { filters, vepStatus } = params;
    const { pageNumber } = filters;
    const response = yield call(listVeps, { ...filters, vepStatus });
    if (response.type === "W") {
        yield put({ type: types.LIST_VEPS_FAILURE });

        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "afip.link.payment.general.error",
                        "<strong>Error.</strong> Pagos ARCA no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else {
            yield put(notificationActions.showNotification(response.data.message, "error", ["vepPayments"]));
        }
    } else {
        const totalPages = response.data.data?.data?.paginatedList?.totalPages;
        const currentList = yield select(afipPaymentLinkSelectors.getVeps);
        yield put({
            type: types.LIST_VEPS_SUCCESS,
            vepsList: currentList.concat(response.data.data?.data?.paginatedList?.elementList),
            totalVepsListPages: totalPages,
            hasMoreData: !!totalPages && pageNumber < totalPages,
        });
    }
}

function* getTaxpayerList({ pageNumber }) {
    const response = yield call(listTaxpayers, { pageNumber });
    if (response.type === "W") {
        yield put({ type: types.LIST_TAXPAYERS_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "afip.link.payment.general.error",
                        "<strong>Error.</strong> Pagos ARCA no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else if (response.data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.data.NO_FIELD),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.message),
                    "error",
                    ["vepPayments"],
                ),
            );
        }
    } else {
        const totalPages = response.data.data?.data?.paginatedList?.totalPages;
        yield put({
            type: types.LIST_TAXPAYERS_SUCCESS,
            taxpayersList: response.data.data?.data?.paginatedList?.elementList,
            totalTaxpayersListPages: totalPages,
            hasMoreData: !!totalPages && pageNumber < totalPages,
        });
    }
}

function* addNewTaxpayer({ params }) {
    const response = yield call(addTaxpayer, params);
    if (response.type === "W") {
        yield put({ type: types.ADD_TAXPAYER_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "vep.taxpayers.add.general.error",
                        "<strong>Error.</strong> En este momento no podés adherir un nuevo contribuyente. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else if (response.data.data.otp) {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.data.otp),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else if (response.data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.data.NO_FIELD),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.message),
                    "error",
                    ["vepPayments"],
                ),
            );
        }
    } else {
        yield put({
            type: types.ADD_TAXPAYER_SUCCESS,
        });
        yield put(
            notificationActions.showNotification(
                i18n.get("vep.taxpayers.add.success", "<strong>Confirmado.</strong> Contribuyente adherido con éxito."),
                "success",
                ["vepPayments"],
            ),
        );
        yield put(afipPaymentLinkActions.listTaxpayer(1));
    }
}

function* deleteTaxpayer({ params }) {
    const response = yield call(deleteVEPTaxpayer, params);
    if (response.type === "W") {
        yield put({ type: types.DELETE_TAXPAYER_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "vep.taxpayers.delete.general.error",
                        "<strong>Error.</strong> En este momento no podés eliminar un nuevo contribuyente. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else if (response.data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.data.NO_FIELD),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.message),
                    "error",
                    ["vepPayments"],
                ),
            );
        }
    } else {
        yield put({
            type: types.DELETE_TAXPAYER_SUCCESS,
        });
        yield put(
            notificationActions.showNotification(
                i18n.get(
                    "vep.taxpayers.delete.success",
                    "<strong>Confirmado.</strong> Contribuyente eliminado con éxito.",
                ),
                "success",
                ["vepPayments"],
            ),
        );
        yield put(afipPaymentLinkActions.listTaxpayer(1));
    }
}

function* deleteVep({ params }) {
    const response = yield call(deleteVEP, params);
    if (response.type === "W") {
        yield put({ type: types.DELETE_VEP_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "vep.delete.general.error",
                        "<strong>Error.</strong> En este momento no podés eliminar un nuevo contribuyente. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else if (response.data.data.NO_FIELD && response.data.data.NO_FIELD !== "returnCode.BAK001E") {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.data.NO_FIELD),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.message),
                    "error",
                    ["vepPayments"],
                ),
            );
        }
    } else {
        yield put({
            type: types.DELETE_VEP_SUCCESS,
        });
        yield put(
            notificationActions.showNotification(
                i18n.get("vep.delete.success", "<strong>Confirmado.</strong> VEP eliminado con éxito."),
                "success",
                ["vepPayments"],
            ),
        );
    }
}

function* accessAfipPortalRequest() {
    const response = yield call(accessAfipPortal);
    if (response.type === "W") {
        yield put({ type: types.ACCESS_AFIP_PORTAL_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "afip.link.payment.general.error",
                        "<strong>Error.</strong> Pagos ARCA no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else if (response.data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.data.NO_FIELD),
                    "error",
                    ["vepPayments"],
                ),
            );
        } else {
            yield put(
                notificationActions.showNotification(
                    "<strong>Error.</strong> ".concat(response.data.message),
                    "error",
                    ["vepPayments"],
                ),
            );
        }
    } else {
        const { token, signature, url } = response?.data?.data?.data;
        const action = "AUTH";

        if (window.cordova) {
            /* MOBILE */
            const query = new URLSearchParams({
                token,
                sign: signature,
                action,
            });
            window.cordova.InAppBrowser.open(
                url.concat("?").concat(query.toString()),
                "_system",
                "hidden=no,location=no,clearsessioncache=yes,clearcache=yes",
            );
        } else {
            /* WEB */
            const form = formUtils.openWindowWithPost(url, {
                token,
                sign: signature,
                action,
            });
            form.submit();
            document.body.removeChild(form);
        }
        yield put({
            type: types.ACCESS_AFIP_PORTAL_SUCCESS,
        });
    }
}

function* downloadVepDetailRequest({ vep, format, isHistoric, vepType }) {
    const vepHitoric = isHistoric;
    const { type, data } = yield call(downloadVepDetail, vep, format, vepHitoric, vepType);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_VEP_DETAIL_FAILURE });
        yield put(notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["vepPayments"]));
    } else {
        const { content, fileName } = data.data;
        downloadPdf(fileName, content);
        yield put({ type: types.DOWNLOAD_VEP_DETAIL_SUCCESS });
    }
}

function* processVepPaymentRequest({ params, formikBag }) {
    const response = yield call(processVepPayment, params);
    const { data } = response;
    formikBag.setSubmitting(false);
    if (response.type === "W") {
        yield put({ type: types.PROCESS_VEP_PAYMENT_FAILURE });

        if (data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "afip.link.payment.general.error",
                        "<strong>Error.</strong> Pagos ARCA no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["VepPaymentConfirmPage"],
                ),
            );
        } else if (data.data.otp) {
            formikBag.setErrors({
                credential: i18n.get("validate.secondFactor.invalid"),
            });
            yield put(
                notificationActions.showNotification("<strong>Error.</strong> ".concat(data.data.otp), "error", [
                    "VepPaymentConfirmPage",
                ]),
            );
        } else if (data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification("<strong>Error.</strong> ".concat(data.data.NO_FIELD), "error", [
                    "VepPaymentConfirmPage",
                ]),
            );
        } else {
            yield put(notificationActions.showNotification(data.message, "error", ["VepPaymentConfirmPage"]));
        }
    } else {
        yield put({ type: types.PROCESS_VEP_PAYMENT_SUCCESS });
        const { code } = data;
        if (code !== "COR020W") {
            yield put(replace(`/vepPayments/newPayment/transaction/${data.idTransaction}`));
        }
    }
}

function* getPaymentSchedule(params) {
    const { isArcaPayment } = params;
    const response = yield call(getPaymentScheduleRequest, isArcaPayment);

    if (response.type === "W") {
        yield put({ type: types.GET_PAYMENT_SCHEDULE_FAILURE });

        let notificationScope = "servicesPayment";
        let message =
            "<strong>Error.</strong> Pagos de servicios no está disponible en este momento. Intentá nuevamente más tarde.";

        if (isArcaPayment && isArcaPayment.isArcaPayment === true) {
            notificationScope = "afipServices";
            message =
                "<strong>Error.</strong> Servicios ARCA no está disponible en este momento. Intentá nuevamente más tarde.";
        }

        if (response.data.code === "BAK615W" || response.data.code === "COR020W") {
            yield put(notificationActions.showNotification(i18n.get("", message), "error", [notificationScope]));
        } else {
            yield put(notificationActions.showNotification(response.data.message, "error", [notificationScope]));
        }
    } else {
        const paymentSchedule = response.data.data?.data?.serviceList;
        yield put({
            type: types.GET_PAYMENT_SCHEDULE_SUCCESS,
            paymentSchedule,
        });
    }
}

function* getDebtByCuit(params) {
    const { cuit } = params;
    const response = yield call(getDebtByCuitRequest, { cuit });

    if (response.type === "W") {
        yield put({ type: types.GET_DEBT_BY_CUIT_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "",
                        "<strong>Error.</strong> Servicios ARCA no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["afipServices"],
                ),
            );
        } else {
            const message = credentialsErrorMessage(response.data?.data);
            yield put(
                notificationActions.showNotification(message || response.data.message, "error", ["afipServices"]),
            );
        }
    } else {
        const afipServicesDebt = response.data.data?.debt;
        const cuitIsAdheredToAfipServices = response.data.data?.cuitIsAdhered;
        yield put({
            type: types.GET_DEBT_BY_CUIT_SUCCESS,
            afipServicesDebt,
            cuitIsAdheredToAfipServices,
        });
    }
}

function* addEntity(params) {
    const { cuit } = params;
    const servicesPaymentData = yield select(afipPaymentLinkSelectors.getServicesPaymentData);
    const response = yield call(addEntityRequest, { cuit });

    if (response.type === "W") {
        yield put({ type: types.AFIP_SERVICES_ADD_ENTITY_FAILURE });

        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "",
                        "<strong>Error.</strong> Servicios ARCA no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["afipServices"],
                ),
            );
        } else {
            yield put(notificationActions.showNotification(response.data.message, "error", ["afipServices"]));
        }
    } else {
        yield put({
            type: types.AFIP_SERVICES_ADD_ENTITY_SUCCESS,
        });
        if (servicesPaymentData === null) {
            yield put(replace(`/arcaPaymentSchedule`));
        } else {
            yield put(replace(`/arcaServices/newPayment/confirm`));
        }
    }
}

function* processServicesPaymentRequest({ params }) {
    const response = yield call(processServicesPayment, params);
    const { data } = response;
    if (response.type === "W") {
        yield put({ type: types.PROCESS_SERVICES_PAYMENT_FAILURE });

        if (data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "afip.link.payment.general.error",
                        "<strong>Error.</strong> Pago AFIP no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["ServicesPaymentConfirmPage"],
                ),
            );
        } else if (data.data.otp) {
            yield put(
                notificationActions.showNotification("<strong>Error.</strong> ".concat(data.data.otp), "error", [
                    "ServicesPaymentConfirmPage",
                ]),
            );
        } else if (data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification("<strong>Error.</strong> ".concat(data.data.NO_FIELD), "error", [
                    "ServicesPaymentConfirmPage",
                ]),
            );
        } else {
            yield put(notificationActions.showNotification(data.message, "error", ["ServicesPaymentConfirmPage"]));
        }
    } else {
        yield put({ type: types.PROCESS_SERVICES_PAYMENT_SUCCESS });
        const { code } = data;
        if (code !== "COR020W") {
            yield put(replace(`/arcaServices/newPayment/transaction/${data.idTransaction}`));
        }
    }
}

function* addServicePreRequest({ params = null }) {
    const categoryId = params?.categoryId || null;
    const response = yield call(addServicesPaymentPre, { categoryId });

    if (response.type === "W") {
        yield put({ type: types.ADD_SERVICE_PRE_FAILURE });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "",
                        "<strong>Error.</strong> Pagos de servicios no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["servicesPayment"],
                ),
            );
        } else {
            const message = credentialsErrorMessage(response.data?.data);
            yield put(
                notificationActions.showNotification(message || response.data.message, "error", ["servicesPayment"]),
            );
        }
    } else {
        const categories = response.data.data?.categories;
        const entities = response.data.data?.entities;
        yield put({
            type: types.ADD_SERVICE_PRE_SUCCESS,
            categories,
            entities,
        });
    }
}

function* verifyServiceScheduleRequest(params) {
    const { servicePaymentData } = params;
    const response = yield call(verifyServiceSchedule, servicePaymentData);

    if (response.type === "W") {
        yield put({
            type: types.VERIFY_SERVICE_SCHEDULED_FAILURE,
        });
        if (response.data.code === "BAK615W") {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "",
                        "<strong>Error.</strong> Pago de servicios no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["servicesPayment"],
                ),
            );
        } else {
            const message = credentialsErrorMessage(response.data?.data);
            yield put(
                notificationActions.showNotification(message || response.data.message, "warning", ["servicesPayment"]),
            );
        }
    } else {
        yield put({
            type: types.VERIFY_SERVICE_SCHEDULED_SUCCESS,
        });

        yield put(replace("/addService/confirm"));
    }
}

function* adheredServiceList() {
    try {
        const response = yield call(adheredServicesList);
        if (response.type === "W") {
            yield put({ type: types.AD_SERVICE_LIST_FAILURE });
            yield put(
                notificationActions.showNotification(i18n.get("service.link.list.error"), "error", [
                    "linkAdheredServices",
                ]),
            );
        } else {
            yield put({
                type: types.AD_SERVICE_LIST_SUCCESS,
                adheredServicesList: response.data.data.adheredServiceList,
            });
        }
    } catch (error) {
        yield put({ type: types.AD_SERVICE_LIST_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("service.link.list.error"), "error", ["linkAdheredServices"]),
        );
    }
}

function* deleteAdheredServiceRequest({ linkCode }) {
    try {
        const response = yield call(deleteAdheredService, linkCode);
        if (response.type === "W") {
            yield put({ type: types.AD_SERVICE_DELETE_FAILURE });
            yield put(
                notificationActions.showNotification(i18n.get("service.link.delete.error"), "error", [
                    "linkAdheredServices",
                ]),
            );
        } else {
            yield put({
                type: types.AD_SERVICE_DELETE_SUCCESS,
            });
            yield put({
                type: types.AD_SERVICE_LIST_REQUEST,
            });
            yield put(
                notificationActions.showNotification(i18n.get("service.link.delete.success"), "success", [
                    "linkAdheredServices",
                ]),
            );
        }
    } catch (error) {
        yield put({ type: types.AD_SERVICE_DELETE_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("service.link.delete.error"), "error", [
                "linkAdheredServices",
            ]),
        );
    }
}

function* editAdheredServiceRequest({ linkCode, alias }) {
    try {
        const response = yield call(editAdheredService, linkCode, alias);
        if (response.type === "W") {
            yield put({ type: types.AD_SERVICE_EDIT_FAILURE });
            yield put(
                notificationActions.showNotification(i18n.get("service.link.edit.error"), "error", [
                    "linkAdheredServices",
                ]),
            );
        } else {
            yield put({
                type: types.AD_SERVICE_EDIT_SUCCESS,
            });
            // actualizo listado
            yield put({
                type: types.AD_SERVICE_LIST_REQUEST,
            });
            yield put(
                notificationActions.showNotification(i18n.get("service.link.edit.success"), "success", [
                    "linkAdheredServices",
                ]),
            );
        }
    } catch (error) {
        yield put({ type: types.AD_SERVICE_EDIT_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("service.link.edit.error"), "error", ["linkAdheredServices"]),
        );
    }
}

function* newServicePaymentPreRequest({ params = null }) {
    const response = yield call(newServicesPaymentPre, params);

    if (response.type === "W") {
        yield put({ type: types.NEW_SERVICE_PAYMENT_PRE_FAILURE });
        if (
            response.data.code === "BAK615W" ||
            (response.data.code === "COR020W" && !Object.keys(response.data.data).includes("CPE_INVALIDO"))
        ) {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "",
                        "<strong>Error.</strong> Pagos de servicios no está disponible en este momento. Intentá nuevamente más tarde.",
                    ),
                    "error",
                    ["servicesPayment"],
                ),
            );
        } else if (response.data.code === "COR020W" && Object.keys(response.data.data).includes("CPE_INVALIDO")) {
            yield put(
                notificationActions.showNotification(response.data?.data?.CPE_INVALIDO, "error", ["servicesPayment"]),
            );
        } else {
            const message = credentialsErrorMessage(response.data?.data);
            yield put(
                notificationActions.showNotification(i18n.get(message) || response.data.message, "error", [
                    "servicesPayment",
                ]),
            );
        }
    } else {
        const categories = response.data.data?.categories;
        const entities = response.data.data?.entities;
        const concepts = response.data.data?.concepts;
        const serviceIsAdhered = response.data.data?.isAdhered;
        const debt = response.data.data?.debt;
        yield put({
            type: types.NEW_SERVICE_PAYMENT_PRE_SUCCESS,
            categories,
            entities,
            concepts,
            serviceIsAdhered,
            servicesPaymentDebt: debt,
        });
    }
}

function* linkServiceRequest({ params, formikBag }) {
    try {
        const response = yield call(linkService, params);
        if (response.type === "W") {
            const { code } = response.data;

            if (code === "COR020W") {
                formikBag.setErrors({
                    credential: i18n.get("validate.secondFactor.invalid"),
                });
                formikBag.setSubmitting(false);
                return;
            }

            yield put({ type: types.LINK_SERVICE_FAILURE });
            yield put(replace(`/linkService/transaction/${response.data.idTransaction}`));
        } else {
            yield put({
                type: types.LINK_SERVICE_SUCCESS,
            });
            yield put(replace(`/linkService/transaction/${response.data.idTransaction}`));
        }
    } catch (error) {
        yield put({ type: types.LINK_SERVICE_FAILURE });
        yield put(replace(`/linkService/transaction/${error.data.idTransaction}`));
    }
}

function* generateServicePaymentRequest({ params, formikBag }) {
    const response = yield call(generateServicePayment, params);
    const { data } = response;
    if (response.type === "W" && data.code !== "BAK615W") {
        formikBag.setSubmitting(false);

        yield put({ type: types.PROCESS_SERVICES_PAYMENT_FAILURE });

        if (data.data.otp) {
            formikBag.setErrors({
                credential: i18n.get("validate.secondFactor.invalid"),
            });
            yield put(
                notificationActions.showNotification("<strong>Error.</strong> ".concat(data.data.otp), "error", [
                    "NewPaymentConfirmPage",
                ]),
            );
        } else if (data.data.NO_FIELD) {
            yield put(
                notificationActions.showNotification("<strong>Error.</strong> ".concat(data.data.NO_FIELD), "error", [
                    "NewPaymentConfirmPage",
                ]),
            );
        } else {
            yield put(notificationActions.showNotification(data.message, "error", ["NewPaymentConfirmPage"]));
        }
    } else {
        yield put({ type: types.PROCESS_SERVICES_PAYMENT_SUCCESS });
        yield put(replace(`/newServicePayment/transaction/${data.idTransaction}`));

        if (params?.params?.addServicesChecked && !data?.data?.serviceAdded) {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "returnCode.BAK619W",
                        "<strong>Error.</strong> No fue posible agendar el servicio. Inténtalo nuevamente más tarde.",
                    ),
                    "error",
                    ["servicePaymentTransactionPage"],
                ),
            );
        }
    }
}

function* listPaymentsHistoryRequest({ params }) {
    try {
        const response = yield call(listPaymentsHistory, params);
        if (response.type === "W") {
            yield put({ type: types.LIST_PAYMENTS_FAILURE, paymentsList: null });
        } else {
            yield put({
                type: types.LIST_PAYMENTS_SUCCESS,
                paymentsList: response.data.data.paymentList,
            });
        }
    } catch (error) {
        yield put({ type: types.LIST_PAYMENTS_FAILURE });
    }
}

export default sagas;
